import { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../../core/axios/axiosInstance";
import countryList from "react-select-country-list";
import { showToast } from "../../../core/data/redux/slices/ToastSlice";
import { useDispatch } from "react-redux";

const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

const goalOptions = [
  { value: "For personal use", label: "For personal use" },
  { value: "Testing for my company", label: "Testing for my company" },
  { value: "Other", label: "Other" },
];

const categoryOptions = [
  { value: "Sales", label: "Sales" },
  { value: "Marketing", label: "Marketing" },
  { value: "IT", label: "IT" },
  { value: "Procurement", label: "Procurement" },
  { value: "Consultant", label: "Consultant" },
  { value: "C-Level", label: "C-Level" },
  { value: "HR", label: "HR" },
  { value: "Field Representative", label: "Field Representative" },
  { value: "Freelancer", label: "Freelancer" },
  { value: "Other", label: "Other" },
];

const employeeCountOptions = [
  { value: "1-10", label: "1-10" },
  { value: "11-50", label: "11-50" },
  { value: "51-200", label: "51-200" },
  { value: "201-500", label: "201-500" },
  { value: "501-1000", label: "501-1000" },
  { value: "1000+", label: "1000+" },
];

const areasOfHelpOptions = [
  { value: "Managing Sales pipelines", label: "Managing Sales pipelines" },
  { value: "Organizing key relationships", label: "Organizing key relationships" },
  { value: "Process automation", label: "Process automation" },
  { value: "Something else", label: "Something else" },
];

const AdminEmailNotifications = () => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const dispatch = useDispatch()
  // Filters
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedEmployeeCount, setSelectedEmployeeCount] = useState([]);
  const [selectedAreasOfHelp, setSelectedAreasOfHelp] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const countries = countryList().getData();
  console.log(history, "history");




  const fetchHistory = async () => {
    try {
      const res = await api.get("/admin/email/get-email");
      setHistory(
        Array.isArray(res.data)
          ? res.data
          : res.data?.emails || res.data?.data || []
      );
    } catch (error) {
      console.error("❌ Failed to fetch email history:", error);
    }
  };

  useEffect(() => {

    fetchHistory();
  }, []);

  const handleSendEmail = async () => {
    if (!subject || !body) {
      alert("Please fill out both subject and message body");
      return;
    }

    if (
      selectedGenders.length === 0 &&
      selectedGoals.length === 0 &&
      selectedCategories.length === 0 &&
      selectedEmployeeCount.length === 0 &&
      selectedAreasOfHelp.length === 0 &&
      selectedCountries.length === 0
    ) {
      if (
        !window.confirm(
          "No filters selected. Do you want to send this email to ALL users?"
        )
      ) {
        return;
      }
    }

    setLoading(true);
    try {
      const payload = {
        subject,
        body,
        gender: selectedGenders.map((g) => g.value),
        goals: selectedGoals.map((g) => g.value),
        categories: selectedCategories.map((c) => c.value),
        employeeCount: selectedEmployeeCount.map((e) => e.value),
        helps: selectedAreasOfHelp.map((a) => a.value),
        country: selectedCountries.map((c) => c.value),
      };

      console.log(payload, "payload for email notification");

      const response = await api.post("admin/email/send-emails", payload);
      console.log(response.data, "response from send email");

      dispatch(
        showToast({ message: "Email Sent", variant: "success" })
      );
      fetchHistory();
      setSubject("");
      setBody("");
      setSelectedGenders([]);
      setSelectedGoals([]);
      setSelectedCategories([]);
      setSelectedEmployeeCount([]);
      setSelectedAreasOfHelp([]);
      setSelectedCountries([]);

      const res = await api.get("/admin/email-history");
      setHistory(
        Array.isArray(res.data)
          ? res.data
          : res.data?.emails || res.data?.data || []
      );
    } catch (error) {
      console.error("❌ Email send failed:", error);
      dispatch(
        showToast({ message: "Email not Sent", variant: "danger" })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Email Form */}
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Send Email Notification</h5>

            {/* Subject */}
            <div className="mb-3">
              <label className="form-label">Subject</label>
              <input
                type="text"
                className="form-control"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Enter email subject"
              />
            </div>

            {/* Body */}
            <div className="mb-3">
              <label className="form-label">Message Body</label>
              <textarea
                className="form-control"
                rows="5"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                placeholder="Enter email message"
              />
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">

                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label">Gender</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      if (selectedGenders.length === genderOptions.length) {
                        setSelectedGenders([]); // Deselect all
                      } else {
                        setSelectedGenders(genderOptions); // Select all
                      }
                    }}
                  >
                    {selectedGenders.length === genderOptions.length ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <Select
                  isMulti
                  options={genderOptions}
                  value={selectedGenders}
                  onChange={setSelectedGenders}
                  placeholder="Select gender(s)"
                />
              </div>

              <div className="col-md-4 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label">Goals</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      if (selectedGoals.length === goalOptions.length) {
                        setSelectedGoals([]); // Deselect all
                      } else {
                        setSelectedGoals(goalOptions); // Select all
                      }
                    }}
                  >
                    {selectedGoals.length === goalOptions.length ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <Select
                  isMulti
                  options={goalOptions}
                  value={selectedGoals}
                  onChange={setSelectedGoals}
                  placeholder="Select goal(s)"
                />
              </div>

              <div className="col-md-4 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label">Categories</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      if (selectedCategories.length === categoryOptions.length) {
                        setSelectedCategories([]); // Deselect all
                      } else {
                        setSelectedCategories(categoryOptions); // Select all
                      }
                    }}
                  >
                    {selectedCategories.length === categoryOptions.length ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <Select
                  isMulti
                  options={categoryOptions}
                  value={selectedCategories}
                  onChange={setSelectedCategories}
                  placeholder="Select category(ies)"
                />
              </div>

              <div className="col-md-4 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label">Employee Count</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      if (selectedEmployeeCount.length === employeeCountOptions.length) {
                        setSelectedEmployeeCount([]); // Deselect all
                      } else {
                        setSelectedEmployeeCount(employeeCountOptions); // Select all
                      }
                    }}
                  >
                    {selectedEmployeeCount.length === employeeCountOptions.length ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <Select
                  isMulti
                  options={employeeCountOptions}
                  value={selectedEmployeeCount}
                  onChange={setSelectedEmployeeCount}
                  placeholder="Select employee count"
                />
              </div>

              <div className="col-md-4 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label">Areas of help</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      if (selectedAreasOfHelp.length === areasOfHelpOptions.length) {
                        setSelectedAreasOfHelp([]); // Deselect all
                      } else {
                        setSelectedAreasOfHelp(areasOfHelpOptions); // Select all
                      }
                    }}
                  >
                    {selectedAreasOfHelp.length === areasOfHelpOptions.length ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <Select
                  isMulti
                  options={areasOfHelpOptions}
                  value={selectedAreasOfHelp}
                  onChange={setSelectedAreasOfHelp}
                  placeholder="Select area(s) of help"
                />
              </div>

              <div className="col-md-4 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label">Country</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      if (selectedCountries.length === countries.length) {
                        setSelectedCountries([]); // Deselect all
                      } else {
                        setSelectedCountries(countries); // Select all
                      }
                    }}
                  >
                    {selectedCountries.length === countries.length ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <Select
                  isMulti
                  options={countries}
                  value={selectedCountries}
                  onChange={setSelectedCountries}
                  placeholder="Select country(ies)"
                />
              </div>
            </div>

            <button
              className="btn btn-success"
              onClick={handleSendEmail}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Email"}
            </button>
          </div>
        </div>

        {/* Email History */}
        <div className="card mt-4">
          <div className="card-body">
            <h5 className="card-title">Email History</h5>
            <table className="table">
              <thead>
                <tr>
                  <th>Subject</th>
                  <th>Body</th>
                  <th>Filters Used</th>
                  <th>Sent On</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(history) && history.length > 0 ? (
                  history.map((item) => (
                    <tr key={item.id}>
                      <td className="scrollable-td">{item.subject}</td>
                      <td className="scrollable-td" style={{ maxWidth: "300px", maxHeight: "80px" }}>{item.body}</td>
                      <td className="scrollable-td" style={{ maxWidth: "300px" }}>
                        <small>
                          <strong>Gender:</strong> {item.filters?.gender?.join(", ") || "-"} <br />
                          <strong>Goals:</strong> {item.filters?.goals?.join(", ") || "-"} <br />
                          <strong>Categories:</strong> {item.filters?.categories?.join(", ") || "-"} <br />
                          <strong>Employee Count:</strong> {item.filters?.employeeCount?.join(", ") || "-"} <br />
                          <strong>Helps:</strong> {item.filters?.helps?.join(", ") || "-"} <br />
                          <strong>Country:</strong> {item.filters?.country?.join(", ") || "-"}
                        </small>
                      </td>

                      <td>
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No emails sent yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminEmailNotifications;








// import { useState, useEffect, useRef } from "react";
// import Select from "react-select";
// import api from "../../../core/axios/axiosInstance";
// import countryList from "react-select-country-list";
// import { showToast } from "../../../core/data/redux/slices/ToastSlice";
// import { useDispatch } from "react-redux";
// import EmojiPicker from "emoji-picker-react"; // ✅ Added

// const genderOptions = [
//   { value: "Male", label: "Male" },
//   { value: "Female", label: "Female" },
//   { value: "Other", label: "Other" },
// ];

// const goalOptions = [
//   { value: "For personal use", label: "For personal use" },
//   { value: "Testing for my company", label: "Testing for my company" },
//   { value: "Other", label: "Other" },
// ];

// const categoryOptions = [
//   { value: "Sales", label: "Sales" },
//   { value: "Marketing", label: "Marketing" },
//   { value: "IT", label: "IT" },
//   { value: "Procurement", label: "Procurement" },
//   { value: "Consultant", label: "Consultant" },
//   { value: "C-Level", label: "C-Level" },
//   { value: "HR", label: "HR" },
//   { value: "Field Representative", label: "Field Representative" },
//   { value: "Freelancer", label: "Freelancer" },
//   { value: "Other", label: "Other" },
// ];

// const employeeCountOptions = [
//   { value: "1-10", label: "1-10" },
//   { value: "11-50", label: "11-50" },
//   { value: "51-200", label: "51-200" },
//   { value: "201-500", label: "201-500" },
//   { value: "501-1000", label: "501-1000" },
//   { value: "1000+", label: "1000+" },
// ];

// const areasOfHelpOptions = [
//   { value: "Managing Sales pipelines", label: "Managing Sales pipelines" },
//   { value: "Organizing key relationships", label: "Organizing key relationships" },
//   { value: "Process automation", label: "Process automation" },
//   { value: "Something else", label: "Something else" },
// ];

// const AdminEmailNotifications = () => {
//   const [subject, setSubject] = useState("");
//   const [body, setBody] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [history, setHistory] = useState([]);
//   const dispatch = useDispatch();

//   // ✅ Emoji Picker state & refs
//   const [openPicker, setOpenPicker] = useState(null); // "subject" | "body" | null
//   const subjectRef = useRef(null);
//   const bodyRef = useRef(null);
//   const pickerRef = useRef(null);

//   // ✅ Close picker when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         pickerRef.current &&
//         !pickerRef.current.contains(event.target) &&
//         !subjectRef.current.contains(event.target) &&
//         !bodyRef.current.contains(event.target)
//       ) {
//         setOpenPicker(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // ✅ Emoji insertion logic
//   const handleEmojiClick = (emojiData, field) => {
//     const emoji = emojiData.emoji;
//     if (field === "subject") {
//       const input = subjectRef.current;
//       const start = input.selectionStart;
//       const end = input.selectionEnd;
//       const newText = subject.slice(0, start) + emoji + subject.slice(end);
//       setSubject(newText);
//       setTimeout(() => {
//         input.selectionStart = input.selectionEnd = start + emoji.length;
//         input.focus();
//       }, 0);
//     } else {
//       const input = bodyRef.current;
//       const start = input.selectionStart;
//       const end = input.selectionEnd;
//       const newText = body.slice(0, start) + emoji + body.slice(end);
//       setBody(newText);
//       setTimeout(() => {
//         input.selectionStart = input.selectionEnd = start + emoji.length;
//         input.focus();
//       }, 0);
//     }
//   };

//   // Filters
//   const [selectedGenders, setSelectedGenders] = useState([]);
//   const [selectedGoals, setSelectedGoals] = useState([]);
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedEmployeeCount, setSelectedEmployeeCount] = useState([]);
//   const [selectedAreasOfHelp, setSelectedAreasOfHelp] = useState([]);
//   const [selectedCountries, setSelectedCountries] = useState([]);

//   const countries = countryList().getData();

//   const fetchHistory = async () => {
//     try {
//       const res = await api.get("/admin/email/get-email");
//       setHistory(
//         Array.isArray(res.data)
//           ? res.data
//           : res.data?.emails || res.data?.data || []
//       );
//     } catch (error) {
//       console.error("❌ Failed to fetch email history:", error);
//     }
//   };

//   useEffect(() => {
//     fetchHistory();
//   }, []);

//   const handleSendEmail = async () => {
//     if (!subject || !body) {
//       alert("Please fill out both subject and message body");
//       return;
//     }

//     if (
//       selectedGenders.length === 0 &&
//       selectedGoals.length === 0 &&
//       selectedCategories.length === 0 &&
//       selectedEmployeeCount.length === 0 &&
//       selectedAreasOfHelp.length === 0 &&
//       selectedCountries.length === 0
//     ) {
//       if (
//         !window.confirm(
//           "No filters selected. Do you want to send this email to ALL users?"
//         )
//       ) {
//         return;
//       }
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         subject,
//         body,
//         gender: selectedGenders.map((g) => g.value),
//         goals: selectedGoals.map((g) => g.value),
//         categories: selectedCategories.map((c) => c.value),
//         employeeCount: selectedEmployeeCount.map((e) => e.value),
//         helps: selectedAreasOfHelp.map((a) => a.value),
//         country: selectedCountries.map((c) => c.value),
//       };

//       const response = await api.post("admin/email/send-emails", payload);

//       dispatch(showToast({ message: "Email Sent", variant: "success" }));
//       fetchHistory();
//       setSubject("");
//       setBody("");
//       setSelectedGenders([]);
//       setSelectedGoals([]);
//       setSelectedCategories([]);
//       setSelectedEmployeeCount([]);
//       setSelectedAreasOfHelp([]);
//       setSelectedCountries([]);

//       const res = await api.get("/admin/email-history");
//       setHistory(
//         Array.isArray(res.data)
//           ? res.data
//           : res.data?.emails || res.data?.data || []
//       );
//     } catch (error) {
//       console.error("❌ Email send failed:", error);
//       dispatch(showToast({ message: "Email not Sent", variant: "danger" }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         {/* Email Form */}
//         <div className="card">
//           <div className="card-body">
//             <h5 className="card-title">Send Email Notification</h5>

//             {/* SUBJECT FIELD */}
//             <div className="mb-3 position-relative">
//               <label className="form-label">Subject</label>
//               <div className="d-flex align-items-center">
//                 <input
//                   ref={subjectRef}
//                   type="text"
//                   className="form-control"
//                   value={subject}
//                   onChange={(e) => setSubject(e.target.value)}
//                   placeholder="Enter email subject"
//                   onClick={() => setOpenPicker(null)}
//                 />
//                 <button
//                   type="button"
//                   className="btn btn-light ms-2"
//                   onClick={() =>
//                     setOpenPicker(openPicker === "subject" ? null : "subject")
//                   }
//                 >
//                   😀
//                 </button>
//               </div>

//               {openPicker === "subject" && (
//                 <div
//                   ref={pickerRef}
//                   style={{
//                     position: "absolute",
//                     zIndex: 1000,
//                      top: "100%",
//             right: 0,
//                     marginTop: "10px",
//                   }}
//                 >
//                   <EmojiPicker
//                     onEmojiClick={(emojiData) =>
//                       handleEmojiClick(emojiData, "subject")
//                     }
//                   />
//                 </div>
//               )}
//             </div>

//             {/* BODY FIELD */}
//             <div className="mb-3 position-relative">
//               <label className="form-label">Message Body</label>
//               <div className="d-flex align-items-start">
//                 <textarea
//                   ref={bodyRef}
//                   className="form-control"
//                   rows="5"
//                   value={body}
//                   onChange={(e) => setBody(e.target.value)}
//                   placeholder="Enter email message"
//                   onClick={() => setOpenPicker(null)}
//                 />
//                 <button
//                   type="button"
//                   className="btn btn-light ms-2 mt-1"
//                   onClick={() =>
//                     setOpenPicker(openPicker === "body" ? null : "body")
//                   }
//                 >
//                   😎
//                 </button>
//               </div>
              

//               {openPicker === "body" && (
//                 <div
//                   ref={pickerRef}
//                   style={{
//                     position: "absolute",
//                     zIndex: 1000,
//                      top: "100%",
//             right: 0,
//                     marginTop: "10px",
//                   }}
//                 >
//                   <EmojiPicker
//                     onEmojiClick={(emojiData) =>
//                       handleEmojiClick(emojiData, "body")
//                     }
//                   />
//                 </div>
//               )}
//             </div>

//             {/* FILTERS + SEND BUTTON (unchanged) */}
//             <div className="row">
//               {/* [all your existing filter fields remain exactly as they were] */}
//               {/* ... */}
//             </div>

//             <button
//               className="btn btn-success"
//               onClick={handleSendEmail}
//               disabled={loading}
//             >
//               {loading ? "Sending..." : "Send Email"}
//             </button>
//           </div>
//         </div>

//         {/* Email History (unchanged) */}
//         <div className="card mt-4">
//           <div className="card-body">
//             <h5 className="card-title">Email History</h5>
//             {/* existing table code remains here */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminEmailNotifications;
